import { render, staticRenderFns } from "./CalculatePage.vue?vue&type=template&id=68d2f08e&scoped=true"
import script from "./CalculatePage.vue?vue&type=script&lang=js"
export * from "./CalculatePage.vue?vue&type=script&lang=js"
import style0 from "./CalculatePage.vue?vue&type=style&index=0&id=68d2f08e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d2f08e",
  null
  
)

export default component.exports